import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"pa-0",attrs:{"fluid":"","grid-list-lg":""}},[(_vm.progressCircle)?_c(VLayout,{staticClass:"justify-center align-center",staticStyle:{"height":"100vh"}},[_c(VProgressCircular,{attrs:{"indeterminate":"","color":"primary","size":"50"}})],1):_c(VLayout,{staticClass:"justify-center align-center",staticStyle:{"height":"100vh"}},[_c(VAlert,{attrs:{"type":"error","color":"error","value":true,"outlined":""}},[_vm._v(" This link is invalid or has expired. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }